this.customElements.define(
  'results-cards',
  class extends HTMLElement {
    async connectedCallback() {
      this.swiperSelector = this.querySelector('.results-cards-swiper');
      this.prevButtonSelector = this.querySelector('.swiper-button-prev');
      this.nextButtonSelector = this.querySelector('.swiper-button-next');

      // Wait for Swiper to be available before initializing
      await this.waitForSwiper();

      new Swiper('.results-cards-swiper', {
        slidesPerView: 1.2,
        spaceBetween: 20,
        loop: true,
        centeredSlides: true,
        pauseOnMouseEnter: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        navigation: {
          nextEl: this.nextButtonSelector,
          prevEl: this.prevButtonSelector,
        },

        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
            centeredSlides: false, // Disable centering on desktop as requested
          },
        },
        speed: 500,
        effect: 'slide',
        grabCursor: true,
        watchOverflow: false,
      });
    }

    waitForSwiper() {
      return new Promise((resolve) => {
        if (window.Swiper) {
          resolve();
          return;
        }

        const checkSwiper = () => {
          if (window.Swiper) {
            resolve();
          } else {
            setTimeout(checkSwiper, 50);
          }
        };

        checkSwiper();
      });
    }
  }
);
